import { ServiceRow } from "../logicBuilder/NewLogicModal";

// Validation function for service selection step
export const validateServiceSelection = (
  serviceRows: ServiceRow[]
): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];

  // Validate each row
  serviceRows.forEach((row, index) => {
    const rowNumber = index + 1;

    // If both are null, the row is completely empty - show error
    if (row.selectedType === null && row.selectedServiceId === null) {
      errors.push(`Service Outcome ${rowNumber} has missing values`);
    }
    // If type is selected but no service, it's incomplete
    else if (row.selectedType !== null && row.selectedServiceId === null) {
      errors.push(
        `Please select a name for the selected type "${row.selectedType}"`
      );
    }
    // If somehow service is selected but no type (shouldn't happen but check anyway)
    else if (row.selectedType === null && row.selectedServiceId !== null) {
      errors.push(`Service Outcome ${rowNumber} has missing type`);
    }
  });

  return {
    isValid: errors.length === 0,
    errors,
  };
};
